import t, { css as e } from "styled-components";
import { MODAL_SIZE as o, MODAL_HEIGHT as d } from "../../../constants/sizes.es.js";
import { DEVICE as a } from "../../../constants/breakpoint.es.js";
const l = {
  [o.sm]: "500px",
  [o.m]: "800px",
  [o.lg]: "1000px",
  [o.xl]: "1200px",
  [o.auto]: "auto"
}, c = t.div.withConfig({
  displayName: "Modal",
  componentId: "sc-gmrf9y-0"
})(["background:var(--color-bg-default);border-radius:var(--radius-l);display:flex;flex-direction:column;", "{border-radius:0;}", ""], a.mobile.max, ({
  size: m
}) => {
  const i = l[m];
  return e(["max-height:", ";max-width:", ";width:", ";@media (max-width:", "){width:90vw;max-width:90vw;margin:0 auto;}", "{height:100%;max-height:", ";max-width:100%;width:100%;}"], d.initial, i, i, i, a.mobile.max, d.full);
}), h = t.div.withConfig({
  displayName: "Body",
  componentId: "sc-gmrf9y-1"
})(["align-items:center;background:var(--color-components-modal-body-bg);display:flex;flex-direction:column;max-height:calc(100% - 113px);overflow-x:hidden;overflow-y:auto;padding:24px;scroll-behavior:smooth;", "{flex-grow:1;}"], a.mobile.max);
export {
  h as Body,
  c as Modal
};
//# sourceMappingURL=style.es.js.map
